import StationsMenu from "./stations";
import { MenuStation } from "../menuStation/MenuStation";
import styles from "./menuMap.module.css";

// Único consumidor restante do menu lateral: a página de Estações.
// Radar, Satélite e WRF têm seus controles no player de cada página.
const MenuMap: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.containerItem}>
        <MenuStation />
        <StationsMenu />
      </div>
    </div>
  );
};

export default MenuMap;
